import React from "react";
import PreviewProfile from "../../Client/Preview";

const ProfileView = () => {
  return <PreviewProfile />;
};

export default ProfileView;
